import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, MobileHeader, ModalRow, theme } from '@sweetgreen/garnish';

import type { Credit } from '@order/graphql';
import { useLocalizationContext } from '@order/Localization';

import { CreditBalanceDetails } from '../CreditBalanceDetails';

export const AvailableCredit = ({
  creditAmount,
  creditDetails,
}: AvailableCreditProps) => {
  const { t, formatPrice } = useLocalizationContext();

  return (
    <>
      <View style={styles.mobileHeaderPadding}>
        <MobileHeader title={t('account.credit.mobile-label')} />
      </View>
      <ModalRow>
        <CreditBalanceDetails creditDetails={creditDetails} />
        <View style={styles.totalCredit}>
          <BodyText size={4} bold>
            {t('account.credit.label')}
          </BodyText>
          <BodyText size={4} bold>
            {formatPrice(creditAmount, 'USD')}
          </BodyText>
        </View>
      </ModalRow>
    </>
  );
};

type AvailableCreditProps = {
  readonly creditAmount: number;
  readonly creditDetails: readonly Credit[];
};

const styles = StyleSheet.create({
  mobileHeaderPadding: {
    paddingTop: theme.spacing.medium,
    paddingHorizontal: theme.spacing.medium,
  },
  totalCredit: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderTopWidth: 1,
    borderTopColor: theme.colors.GREEN_1,
    paddingVertical: theme.spacing.large,
  },
});
